import Vue from 'vue'
import App from './App.vue'
import firebase from 'firebase';
import router from './router';
import Vuelidate from 'vuelidate'
import VeeValidate from 'vee-validate';
// import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
Vue.config.productionTip = false

let config = {
  apiKey: "AIzaSyCJFB9ECvyxhyz35DbfkwnfGfhOmAWfYmo",
  authDomain: "ambassadorcars-venturex.firebaseapp.com",
  databaseURL: "https://ambassadorcars-venturex.firebaseio.com",
  projectId: "ambassadorcars-venturex",
  storageBucket: "ambassadorcars-venturex.appspot.com",
  messagingSenderId: "528792391569",
  appId: "1:528792391569:web:498bdaeb38db7f4a6f1430",
  measurementId: "G-KD388E73TM"
};
firebase.initializeApp(config);

Vue.use(Vuelidate);

// Vue.use(VuetifyGoogleAutocomplete, {
//   apiKey: 'AIzaSyBAkz1_0_9Oy9v0YQgWKruWRpLTL32xOcY', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
//   language: 'en',
// });
// Vue.use(VeeValidate);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
